import React, { FC } from 'react'
import classNames from 'classnames'
import { CheckBox } from '@/atoms/CheckBox'
import { FlexColumn, FlexRow } from '@/atoms/FlexContainers'
import { GuildShield } from '@/atoms/Icons/GuildShield'
import { CaptionMD, EyebrowSM, TitleXS } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { getGuildUpsellCheckboxText } from '../../utils'

export interface Props {
  isChecked: boolean
  onChange: () => void
  projectSlug: string
}

const gildedGuildClassName =
  'bg-[linear-gradient(166.78deg,#EDD7C6_1.42%,#D6A177_14.6%,#FEDEC6_39.98%,#D48D59_60.48%,#A66141_85.7%,#612B12_94.6%)]'

export const ExpressGuildUpsellCheckbox: FC<Props> = ({ isChecked, onChange, projectSlug }) => {
  const { t } = useTranslate('pif')

  return (
    <div onClick={onChange} className={classNames('rounded-lg p-[2px] cursor-pointer relative', gildedGuildClassName)}>
      <FlexColumn className="gap-2 rounded-lg bg-white px-3 py-4">
        <FlexRow className="h-full !items-start gap-1">
          <CheckBox
            wrapperClassName="-mt-[6px]"
            checked={isChecked}
            onChange={onChange}
            checkboxSize={16}
            uncheckedClassName="!border-core-gray-600 !w-4 !h-4 !min-w-4 !min-h-4 !rounded-[2px] cursor-pointer"
            checkedClassName={classNames(
              '!w-4 !min-w-4 !h-4 !min-h-4 !rounded-[2px] cursor-pointer',
              gildedGuildClassName,
            )}
          />
          <FlexColumn>
            <FlexRow className="mb-[2px] gap-1">
              <GuildShield size={18} />
              <TitleXS weight="bold">{t('freePremiumMembership', 'Free Premium Membership')}</TitleXS>
            </FlexRow>
            <EyebrowSM color="core-gray-600" weight="bold" className="mb-2">
              {t('pifGuildUpsellExpressCheckoutValue', 'MONTHLY')}
            </EyebrowSM>

            <CaptionMD>{getGuildUpsellCheckboxText(projectSlug, t)}</CaptionMD>
          </FlexColumn>
        </FlexRow>
      </FlexColumn>
    </div>
  )
}
